<template>
  <div class="container">
    <div class="panel">
      <div class="tab" tabindex="0" @keypress.enter="toggleAccordion('personalTab')" role="tab">
        <input type="radio" value="personalTab" id="accordion-header-1" name="personalTab" v-model="activeTab"
        @click="toggleAccordion('personalTab')" aria-controls="personalInfo">
        <label class="tab-label tabtitle" for="accordion-header-1">Profile & Credentials</label>
        <div class="tab-content">
          <PersonalInfo/>
          <Credentials/>
        </div>
      </div>
      <div class="tab" tabindex="0" @keypress.enter="toggleAccordion('registrationTab')" role="tab">
        <input type="radio" value="registrationTab" id="accordion-header-2" name="registrationTab" v-model="activeTab" 
        @click="toggleAccordion('registrationTab')">
        <label class="tab-label" for="accordion-header-2">Registration</label>
        <div class="tab-content">
          <Registration/>
        </div>
      </div>
      <div class="tab" tabindex="0" @keypress.enter="toggleAccordion('adjudicationTab')" role="tab">
        <input type="radio" value="adjudicationTab" id="accordion-header-3" name="adjudicationTab" v-model="activeTab" 
        @click="toggleAccordion('adjudicationTab')">
        <label class="tab-label" for="accordion-header-3">Adjudication</label>
        <div class="tab-content">
          <Adjudication/>
        </div>
      </div>
    </div>

    <AsideForLinks />
  </div>
</template>

<script>
import PersonalInfo from '../profile/PersonalInfo.vue';
import Credentials from '../profile/Credentials.vue';
import Registration from '../profile/Registration.vue';
import Adjudication from '../profile/Adjudication.vue';
import { mapActions, mapGetters } from 'vuex';
import * as COMMONS from '../../store/_commons';
import AsideForLinks from '../confirmation/AsideForLinks.vue';

export default {
    name : 'Tab',
      components : {
        PersonalInfo,
        Credentials,
        Registration,
        Adjudication,
        AsideForLinks
      },
      data () {
        return {
          activeTab: 'personalTab',
          personalTab: false,
          registrationTab: false,
          adjudicationTab: false,
          personalTabCount: 0,
          registrationTabCount: 0,
          adjudicationTabCount: 0
        }
      },
      computed: {
        ...mapGetters({
          personalInfo: COMMONS.GUEST_PERSONAL_INFO,
          registrationInfo: COMMONS.GUEST_REGISTRATION_INFO,
          adjudicationLicenseInfo: COMMONS.GUEST_ADJUDICATION_LICENSE_INFO,
          adjudicationCommercialLicenseInfo: COMMONS.GUEST_ADJUDICATION_COMMERCIAL_LICENSE_INFO,
          adjudicationRegistrationInfo: COMMONS.GUEST_ADJUDICATION_REGISTRATION_INFO,
        }),
      },
      methods: {
        ...mapActions({
          getPersonalProfileInformation: COMMONS.GUEST_PROFILE,
          getRegistrationInformation: COMMONS.GUEST_REGISTRATION,
          getGuestLogout: COMMONS.GUEST_LOGIN_GET_LOGOUT,
          getAdjudicationInformation: COMMONS.GUEST_ADJUDICATION,
        }),
        
        toggleAccordion(tabName) {
          window.scroll(0,0);
          if (this.activeTab == tabName) {
            this.activeTab = null;
          } else (this.activeTab = tabName)
          if (tabName == 'registrationTab') {
            this.getRegistrationInformationData();
          }
          if (tabName == 'adjudicationTab') {
            this.getAdjudicationInformationData();
          }
        },
        getRegistrationInformationData() {
          if(this.registrationTabCount == 0) {
            this.getRegistrationInformation();
            this.registrationTabCount = 1;
          }
        },
        getAdjudicationInformationData() {
          if(this.adjudicationTabCount == 0) {
            this.getAdjudicationInformation();
            this.adjudicationTabCount = 1;
          }
        }
      },

      mounted() {
        window.scrollTo(0,0);
      },
      destroy() {
        this.personalTabCount = 0;
        this.registrationTabCount = 0;
        this.adjudicationTabCount = 0;
      }
    }
</script>

<style scoped lang="scss">
.container {
  display: flex;
  gap: 2rem;
}
input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
/* Accordion styles */
.panel {
  overflow: hidden;
  width: 80%;
}
.tab {
  width: 100%;
  overflow: hidden;
  &:focus {
    outline-color:orange;
  }
  &-label {
    display: flex;
    justify-content: space-between;
    padding: 1em;
    background: var(--ri-light-blue);
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 0px;
    /* Icon */
    &:hover {
      background: orange;
    }
    &::after {
      content: "+";
      width: 1em;
      height: 1em;
      text-align: center;
      transition: all .35s;
    }
  }
  &-content {
    max-height: 0;
    display: none;
    padding: 0 1em;
    color: black;
    transition: all .35s;
    border: 1px solid  var(--ri-gray);
  }
  .tabtitle{
    margin-top: 0rem;
  }
}

// :checked
input:checked {
  + .tab-label {
    &::after {
      content: "-";
    }
  }
  ~ .tab-content {
    max-height: 100%;
    display: block;
    padding: 1em;
  }
}

.right-panel{
  overflow: hidden;
  margin-top: 16px;
  .tab-right {
    .tab-label-text{
      background: var(--ri-light-blue);
      display: flex;
      justify-content: space-between;
      padding: 1em;
      background: var(--ri-light-blue);
      font-weight: bold;
      cursor: pointer;
      &::after {
        content: none; 
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .panel{
    width: 100%;
  }
  .container {
    display: block;
    gap: 2rem;
  }
  .right-panel{
    overflow: hidden;
    margin-top: 16px;
    width: 100%;
    .tab-right {
      .tab-label-text{
        background: var(--ri-light-blue);
        display: flex;
        justify-content: space-between;
        padding: 1em;
        background: var(--ri-light-blue);
        font-weight: bold;
        cursor: pointer;
        &::after {
          content: none; 
        }
      }
    }
  }
}
</style> 